import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { useState } from 'react'
import { llmReasoningApi } from '../api/client'
import './LLMCadenceToggle.css'

export function LLMCadenceToggle() {
  const qc = useQueryClient()
  const env = useQuery({
    queryKey: ['llm-reasoning-envelope'],
    queryFn: llmReasoningApi.envelope,
    refetchInterval: 60000,
  })
  const [error, setError] = useState<string | null>(null)

  const mutation = useMutation({
    mutationFn: (enabled: boolean) => llmReasoningApi.setCadence(enabled),
    onSuccess: () => {
      setError(null)
      qc.invalidateQueries({ queryKey: ['llm-reasoning-envelope'] })
    },
    onError: (e: Error) => {
      setError(e.message || 'Toggle failed')
    },
  })

  const enabled = env.data?.cadence_enabled ?? false
  const interval = env.data?.cadence_interval_seconds ?? null
  const disabled = mutation.isPending || env.isLoading

  return (
    <div className="card llm-cadence-toggle">
      <h3>LLM cadence</h3>
      {env.isLoading && <p className="llm-muted">Loading…</p>}
      {env.isError && (
        <p className="llm-muted">Failed to load cadence configuration.</p>
      )}
      {env.data && (
        <>
          <div className="llm-cadence-row">
            <label className="llm-cadence-switch">
              <input
                type="checkbox"
                checked={enabled}
                disabled={disabled}
                onChange={(e) => mutation.mutate(e.target.checked)}
              />
              <span className="llm-cadence-track" />
            </label>
            <span className="llm-cadence-state">
              {enabled ? 'Running' : 'Paused'}
            </span>
          </div>
          <p className="llm-muted llm-cadence-interval">
            Interval: {interval !== null ? `${interval}s` : '— (event-driven only)'}
          </p>
        </>
      )}
      {error && <p className="llm-cadence-error">{error}</p>}
    </div>
  )
}
